import { Tooltip } from '@material-ui/core';
import React from 'react';

interface IFlexibleBiddingIconWithTooltipProps {
  placement?:
    | 'top'
    | 'left'
    | 'right'
    | 'bottom'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start';
  width?: number;
  height?: number;
  title?: string;
}
export function FlexibleBiddingIconWithTooltip({
  placement = 'top',
  width = 16,
  height = 16,
  title = 'This feature allows high bids from this bidder to compete above the nominal tier',
}: IFlexibleBiddingIconWithTooltipProps) {
  return (
    <Tooltip title={title} placement={placement}>
      <span>
        <img src='/assets/shared/svg/FlexBidding.svg' width={`${width}px`} height={`${height}px`} />
      </span>
    </Tooltip>
  );
}
